import React,{useState} from 'react'
import { useDispatch,useSelector } from 'react-redux'
import { modalToggleReset } from 'redux/actions/general'
export default function Sortir({modal_data,modal_action}) {
    const dispatch = useDispatch()
    const [sort, setsort] = useState('terbaru')
    const persist = useSelector(state => state.persist)
    const reducer = useSelector(state => state.reducer)
    const {forum_sort,comment_sort}=persist
    const {beranda}=reducer

    const sortToggle=(key)=>{  
        // console.log(`key`, key)

       modal_data.actionSort(key)
        dispatch(modalToggleReset())
    }
    return (
        <div>
            <div className={modal_action==='comment_sort'?comment_sort===1?'sortir-item-active':'sortir-item':forum_sort===1?'sortir-item-active':'sortir-item'} onClick={()=>sortToggle(1)}>
                <p className='font-nunito margin-0'>Terbaru</p>
            </div>
            <div className={modal_action==='comment_sort'?comment_sort===2?'sortir-item-active':'sortir-item':forum_sort===2?'sortir-item-active':'sortir-item'} onClick={()=>sortToggle(2)}>
                <p className='font-nunito margin-0'>Termenarik</p>
            </div>
            {modal_action!=='comment_sort'&&
                <>
                    <div className={forum_sort===3?'sortir-item-active':'sortir-item'} onClick={()=>sortToggle(3)}>
                        <p className='font-nunito margin-0'>Terjawab <span>{beranda!==null&&beranda.countTerjawab!==0&&`(${beranda.countTerjawab})`}</span></p>
                    </div>
                    <div className={forum_sort===4?'sortir-item-active':'sortir-item'} onClick={()=>sortToggle(4)}>
                        <p className='font-nunito margin-0'>Belum Terjawab <span>{beranda!==null&&beranda.countBelumTerjawab!==0&&`(${beranda.countBelumTerjawab})`}</span></p>
                    </div>
                </>
            }
        </div>
    )
}
